<template>
  <div>
    <label
      >{{ field.field_name }}
      <span class="text-danger" v-if="field.required">*</span></label
    ><br />
    <textarea
      :class="['form-control input-custom', { error: field.validation }]"
      rows="3"
      :name="field.name"
      v-model="field.value"
      
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "FieldTextAreaInput",
  props: {
    field: {
      required: true,
      type: Object,
    },

  },
};
</script>

<style lang="scss" scoped>
.input-custom.error {
  border-color: red !important;
}
.text-error {
  color: #ff0000;
  font-size: 14px !important;
  font-weight: normal !important;
}
</style>
